import { Avatar, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import Friendsmodal from './friendsmodal/friendsmodal';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import { getClass } from '../../../../../api/class/class';
import { openNotificationWithIcon } from '../../../../../utils/helper';

interface SuggestFriend {
  _id: string;
  userAvatarURL: string;
  firstName: string;
}

const Studentfriends = () => {
  const [showFriend, setShowFriend] = useState(false);
  const [suggestFriends, setSuggestFriends] = useState<SuggestFriend[]>([]);
  const [loading, setLoading] = useState(false);

  const closeFriendsModal = () => {
    setShowFriend(false);
  };

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;



  const fetchClass = async () => {
    try {
      setLoading(true);
      const classIds = user?.classes || [];
      const studentPromises = classIds.map(async (classId: string) => {
        const res = await getClass(classId);
        const { data } = res?.data;
        return data.students;
      });
      const studentLists = await Promise.all(studentPromises);
      const suggestFriends = studentLists.flat();

      const filteredSuggestFriends = suggestFriends.filter(
        (friend) => !user?.friends?.includes(friend._id) && friend._id !== user._id
      );

      setSuggestFriends(filteredSuggestFriends);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error?.response) {
        openNotificationWithIcon(
          'error',
          'Get Friends',
          `${error?.response?.data?.message || 'Something went wrong'}`
        );
      } else {
        openNotificationWithIcon(
          'error',
          'Get Friends',
          'Something went wrong'
        );
      }
    }
  };

  useEffect(() => {
    fetchClass();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <div>
            <div className='flex justify-end'>
              <p className='w-fit cursor-pointer text-base text-appcolorpurple'>
                Add Friend
              </p>
            </div>

            <div className='mt-4'>
              <div>
                {user?.friends?.length === 0 ? (
                  <p className='pl-10 pt-5 text-base text-appcolorblackfainteleven'>
                    You have no friends
                  </p>
                ) : (
                  user?.friends?.map((item: []) => (
                    <div
                      key={`fpt-${item}`}
                      className='mb-0 flex items-center justify-between p-4'>
                      <div className='flex items-center'>
                        <div className='flex items-center'>
                          <Avatar
                            src='/img/vectors/userfemale.svg'
                            style={{
                              border: '2px solid #FBE0FF',
                              borderRadius: '50%',
                              width: '3rem',
                              height: '3rem',
                            }}
                          />

                          <div className='ml-3'>
                            <p className='mb-1 text-base font-semibold text-appcolorblack'>
                              Ella
                            </p>
                            <p className='mb-1 text-base   text-appcolorblack'>
                              40000FP
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className=''>
                        <img
                          src='/img/vectors/caretright.svg'
                          alt='caretright'
                          className='cursor-pointer'
                          onClick={() => {
                            setShowFriend(true);
                          }}
                        />
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <div className='rounded-[30px] bg-appcolororangefaint p-8'>
            <p className='w-fit text-[18px] leading-[107%] text-appcolorpurple'>
              Suggested Friends
            </p>

            <div>
              <div>
                {suggestFriends && suggestFriends.length > 0 ? (
                  suggestFriends.slice(0, 6).map((item: SuggestFriend) => (
                    <div
                      key={`fpt-${item._id}`}
                      className='mb-0 flex items-center justify-between p-4'>
                      <div className='flex items-center'>
                        <div className='flex items-center'>
                          <Avatar
                            src={
                              item.userAvatarURL || '/img/vectors/usertag.svg'
                            }
                            style={{
                              border: '2px solid #FBE0FF',
                              borderRadius: '50%',
                              width: '3rem',
                              height: '3rem',
                            }}
                          />

                          <div className='ml-3'>
                            <p className='mb-1 text-base font-semibold text-appcolorblack'>
                              {item.firstName}
                            </p>
                            <p className='mb-1 text-base text-appcolorblack'>
                              40000FP
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className=''>
                        <img
                          src='/img/vectors/adduser.svg'
                          alt='adduser'
                          className='cursor-pointer'
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No friend suggestions available.</p>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {showFriend ? (
        <Friendsmodal open={showFriend} closeModal={closeFriendsModal} />
      ) : null}
    </div>
  );
};

export default Studentfriends;
